export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";